module.exports = __webpack_public_path__ + "static/media/loading.93b36c3e.gif";